var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayrollSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6087 6.48454L6.48352 19.6097L5.08737 18.2136L18.2125 5.08839H10.7223V3.11365H21.5834V13.9748H19.6087V6.48454Z",
    fill: "#005048"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollSuccess);
export default __webpack_public_path__ + "static/media/payroll-success.fed14b539c8a20feb3551f02cfe8bda5.svg";
export { ForwardRef as ReactComponent };